import { render, staticRenderFns } from "./tableRules.vue?vue&type=template&id=8373139c&scoped=true"
import script from "./tableRules.vue?vue&type=script&lang=js"
export * from "./tableRules.vue?vue&type=script&lang=js"
import style0 from "./tableRules.vue?vue&type=style&index=0&id=8373139c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8373139c",
  null
  
)

export default component.exports